(function (w, d, $) {
	var $d = $(d);
	var $b;

	$(function () {
		$b = $('body');
	});
})(window, document, window.jQuery); 